import { FC, useEffect, useState } from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { fetchData, toasterrormsg } from '../../../../reusable'
import clsx from 'clsx'
import CircularProgress from '@mui/material/CircularProgress'
import { Link } from 'react-router-dom'
import { Tr } from '../../../i18n/Tr'

interface HeaderNotificationsMenuProps {
  show?: number // Define 'show' prop type
}

const HeaderNotificationsMenu: FC<HeaderNotificationsMenuProps> = ({ show }) => {
  let t = Tr()

  const [notifications, setNotifications] = useState<any[]>([]) // Store all loaded notifications
  const [loading, setLoading] = useState(false) // Track loading state
  const [hasMore, setHasMore] = useState(true) // Track if more notifications are available
  const [offset, setOffset] = useState(0) // Offset for API calls
  const LIMIT = 5 // Number of notifications per API call

  const notificationListApiCall = async () => {
    if (loading || !hasMore) return // Prevent duplicate calls

    setLoading(true)

    const adminData = JSON.parse(sessionStorage.getItem('admin') || '{}')
    const adminId = adminData.adminId
    const mainadminId = adminData.mainadminId

    const param: any = {
      adminId: mainadminId == "0" ? "0" : adminId,
      offset: offset,
      limit: LIMIT,
    }
    const response = await fetchData('admin/notificationlist', param)

    if (response.status == '200') {
      const data = response.data

      setNotifications((prev) => [...prev, ...data])
      setOffset((prev) => prev + LIMIT)
      setHasMore(data.length === LIMIT)
    } else {
      toasterrormsg(response.data.message)
    }

    setLoading(false)
  }

  useEffect(() => {
    if (show !== undefined && show !== 0 && show !== null) {
      notificationListApiCall() // Initial API call
    }
  }, [show])

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const element = e.currentTarget
    if (element.scrollHeight - element.scrollTop === element.clientHeight && hasMore && !loading) {
      notificationListApiCall()
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{
          backgroundImage: `url('${toAbsoluteUrl('/media/misc/menu-header-bg.jpg')}')`,
        }}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>{t("Notifications")}</h3>
      </div>

      <div
        className='scroll-y mh-325px my-5 px-8'
        onScroll={handleScroll} // Listen for scroll events
      >
        {notifications.map((item: any, index) => {
          let generateUrl =
            item.actionType == 'BOOKINGDETAIL-HOTEL'
              ? 'viewhotelbookingdetails'
              : item.actionType == 'BOOKINGDETAIL-SPACE'
                ? 'viewspacebookingdetails'
                : item.actionType == 'BOOKINGDETAIL-TOUR'
                  ? 'viewtourbookingdetails'
                  : item.actionType == 'PROFILE'
                    ? 'viewvendor/vendordetail/personaldetail'
                    : item.actionType == 'USER PROFILE'
                      ? 'viewuser'
                      : item.actionType == 'SPACERENTAL' ? "viewspacerentals" : item.actionType == 'HOTEL' ? "viewhotels" : ""

          let locationState = item.actionType.includes('BOOKING')
            ? 'bookingId'
            : item.actionType.includes('PROFILE')
              ? 'vendorId'
              : ''

          return (
            <>
              <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-${item.state}`)}>
                      <KTIcon iconName={'information-5'} className={`fs-2 text-primary`} />
                    </span>
                  </div>
                  <div className='mb-0 me-2'>
                    <Link
                      to={generateUrl}
                      state={{ [locationState]: item.actionTypeId }}
                      className='fs-6 text-gray-800 text-hover-primary fw-bolder'
                    >
                      {item.title}
                    </Link>
                    <div className='text-gray-400 fs-7'>{item.message}</div>
                    {/* <div className='text-gray-400 fs-7'>{item.actionType}</div> */}
                  </div>
                </div>
                <span className='badge badge-light fs-8'>{item.created}</span>
              </div>
            </>
          )
        })}

        <div className='d-flex justify-content-center'>
          {loading && <CircularProgress className='w-10' />}
        </div>

        {!hasMore && !loading && (
          <div className='text-center text-gray-500 fw-bold mb-3'>No more Notifications</div>
        )}
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }
